import React, { useContext } from 'react';
import { FaRegUser } from 'react-icons/fa6';
import { LuBot } from 'react-icons/lu';
import { AdminSocket } from '../../context/WebSocketContext';

const Editor = ({ chatDetails }) => {
    const { admin: messages } = useContext(AdminSocket);
    // Chat socket functionality disabled - using chatDetails directly as fallback
    const displayMessages = messages.length > 0 ? messages : (chatDetails?.chat || []);

    // useEffect(() => {
    //     setAdmin(chatDetails?.chat || []);
    // }, [chatDetails?.chat, setAdmin]);

    // Editor input temporarily disabled; editor setup removed

    // Handlers for image upload, emoji, and send are removed while input is hidden

    return (
        <>
            <div>
                {displayMessages
                    .filter(item => 
                        item.message !== 'admin_connected' && 
                        item.message !== 'admin_disconnected' &&
                        item.sender !== 'System'
                    )
                    .map((item, i) => (
                    <div key={i} className="mb-6">
                        <div className="flex flex-col w-full -mt-2">
                            {item.sender === 'Client' ? (
                                <div className="flex flex-row-reverse justify-end w-full gap-3 mt-2">
                                    <div className="bg-gray-300 w-8 h-8 rounded-full flex items-center justify-center text-xl text-black mt-2">
                                        <FaRegUser />
                                    </div>
                                    <div className="flex flex-col items-end gap-3 mt-3 w-full">
                                        <div className="flex items-center flex-row-reverse gap-2">
                                            <p className="text-sm font-medium text-black">{item.sender}</p>
                                            <span className="ml-1 text-xs text-gray-400">
                                                {(() => {
                                                    try {
                                                        const date = new Date(item.created_at || item.timestamp || Date.now());
                                                        if (isNaN(date.getTime())) {
                                                            return new Date().toLocaleTimeString([], {
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                                hour12: true,
                                                            });
                                                        }
                                                        return date.toLocaleTimeString([], {
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true,
                                                        });
                                                    } catch (error) {
                                                        return new Date().toLocaleTimeString([], {
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true,
                                                        });
                                                    }
                                                })()}
                                            </span>
                                        </div>
                                        <p className="bg-gray-100 text-black text-sm p-2 rounded-md">
                                            {item.message}
                                        </p>
                                    </div>
                                </div>
                            ) : (
                                <div className="flex gap-3 mt-2">
                                    <div className="bg-gray-300 w-8 h-8 rounded-full flex items-center justify-center text-xl text-black mt-2">
                                        {item.sender === 'AI Assistant' ? <LuBot /> : <FaRegUser />}
                                    </div>
                                    <div className="flex flex-col gap-3 mt-3">
                                        <p className="text-sm font-medium text-black">
                                            {item.sender}
                                            <span className="ml-1 text-xs text-gray-400">
                                                {(() => {
                                                    try {
                                                        const date = new Date(item.created_at || item.timestamp || Date.now());
                                                        if (isNaN(date.getTime())) {
                                                            return new Date().toLocaleTimeString([], {
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                                hour12: true,
                                                            });
                                                        }
                                                        return date.toLocaleTimeString([], {
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true,
                                                        });
                                                    } catch (error) {
                                                        return new Date().toLocaleTimeString([], {
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true,
                                                        });
                                                    }
                                                })()}
                                            </span>
                                        </p>
                                        <p className="bg-gray-100 text-black text-sm p-2 rounded-md">
                                            {item.message}
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            {/**
             * Write message component (editor input, attachments, emoji picker, send button)
             * temporarily hidden per request. Preserved in comments for future use.
             */}
            {/**
            <div className="flex items-end gap-3 p-4 w-full border-t-2 rounded relative">
                <EditorContent
                    editor={editor}
                    className="w-full max-h-[80px] border bg-white p-2 rounded"
                />

                <div className="flex flex-col items-center gap-2 mt-2 relative">
                    <button
                        onClick={() => fileInputRef.current.click()}
                        className="border-2 border-gray-200 p-2 rounded"
                    >
                        <LuPaperclip />
                    </button>
                    <button
                        onClick={() => setShowEmojiPicker(v => !v)}
                        className="border-2 border-gray-200 p-2 rounded"
                    >
                        <BsEmojiSmile />
                    </button>
                    <button
                        onClick={sendMessage}
                        className="bg-green text-white p-2 rounded"
                    >
                        <BsSend />
                    </button>

                    {showEmojiPicker && (
                        <div className="absolute bottom-16 right-0 z-50">
                            <Picker data={data} onEmojiSelect={addEmoji} />
                        </div>
                    )}
                </div>

                <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    onChange={handleImageUpload}
                    style={{ display: 'none' }}
                />
            </div>
            */}
        </>
    );
};

export default Editor;
